module.exports = "<span class=\"badge badge-outline-dark font-size-12\">\n    <i *ngIf=\"icon\" class=\"{{icon}}\">&nbsp;</i>\n    {{id.toString()}}\n</span>\n"